import { render, staticRenderFns } from "./InstrumentCatalogue.vue?vue&type=template&id=77dd3530"
import script from "./InstrumentCatalogue.vue?vue&type=script&lang=ts"
export * from "./InstrumentCatalogue.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentCatalogue.vue?vue&type=style&index=0&id=77dd3530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports